import { render, staticRenderFns } from "./AmlReportPopover.vue?vue&type=template&id=27a7a3ed&scoped=true&lang=pug"
import script from "./AmlReportPopover.vue?vue&type=script&lang=js"
export * from "./AmlReportPopover.vue?vue&type=script&lang=js"
import style0 from "./AmlReportPopover.vue?vue&type=style&index=0&id=27a7a3ed&prod&scoped=true&lang=css"
import style1 from "./AmlReportPopover.vue?vue&type=style&index=1&id=27a7a3ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7a3ed",
  null
  
)

export default component.exports